import { createReducer } from 'typesafe-actions';
import { dashboard } from './actions';
import { DashboardResponse } from './types';
import { RequestStatus } from 'utils/types';

type State = {
  data: DashboardResponse[] | null;
  message: string | null;
  status: RequestStatus;
};

const initialState: State = {
  data: null,
  message: null,
  status: RequestStatus.INIT,
};

const dashboardReducer = createReducer(initialState)
  .handleAction(dashboard.request, (state) => ({
    ...state,
    data: null,
    message: null,
    status: RequestStatus.PENDING,
  }))
  .handleAction(dashboard.success, (state, action) => ({
    ...state,
    data: [
      ...action.payload,
    ],
    message: null,
    status: RequestStatus.SUCCESS,
  }))
  .handleAction(dashboard.failure, (state, action) => ({
    ...state,
    data: null,
    message: action.payload.message,
    status: RequestStatus.FAILED,
  }));

export default dashboardReducer;
